module.exports = __webpack_public_path__ + "static/img/logo.f50963b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo.png
// module id = vJvE
// module chunks = 49